import React from "react";

const NotFound = () => {
  return (
    <div>
      <img
        src={"https://i.ibb.co/4S6c98V/3819740.jpg"}
        className="w-100"
        height="800px"
        alt=""
      />
    </div>
  );
};

export default NotFound;
